import React from 'react';
import { formatCurrency } from '../gameData';

function PoliceDialog({ show, onChoice, fine, bribe }) {
  if (!show) return null;

  return (
    <dialog open={show}>
      <h3>🚨 Police Encounter 🚨</h3>
      <p>Choose your action:</p>
      <div className="police-options">
        <button onClick={() => onChoice("1")}>
          Pay Fine ({formatCurrency(fine)}) — lose your stash
        </button>
        <button onClick={() => onChoice("2")}>
          Bribe ({formatCurrency(bribe)}) — keep your stash
        </button>
        <button onClick={() => onChoice("3")}>
          Run — 50% clean getaway, 50% busted
        </button>
      </div>
      <p className="police-warning">Can't cover the bribe? The loan shark fronts it. Assets are always safe.</p>
    </dialog>
  );
}

export default PoliceDialog; 